import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { grid } from '@finect/tabular-utils/grid';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1l4fl2y-0"
})(["display:block;padding:0 0 36px;border-radius:8px;margin-bottom:42px;"]);
export var Title = styled.h4.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1l4fl2y-1"
})(["", ";", ";margin-bottom:56px;color:", ";text-align:center;"], getFont(1, 'compact'), minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(2, 'compact')), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiDD;
});
export var Subtitle = styled.p.withConfig({
  displayName: "partials__Subtitle",
  componentId: "sc-1l4fl2y-2"
})(["", ";margin-bottom:24px;color:", ";", ";span{font-weight:700;}"], getFont(0), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.terciary;
}, minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", "px;\n  "])), grid(6)));
export var Actions = styled.div.withConfig({
  displayName: "partials__Actions",
  componentId: "sc-1l4fl2y-3"
})(["display:flex;flex-flow:row;"]);
export var Action = styled.div.withConfig({
  displayName: "partials__Action",
  componentId: "sc-1l4fl2y-4"
})(["width:50%;cursor:pointer;color:", ";text-align:center;&:not(:first-child){border-left:1px solid ", ";}&:hover{color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiD;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.ui;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.uiDD;
});